const OAUTH_AUTHORIZE_PATH = "/integrated-apps/v1/oauth/authorize"

/**
 * The one absolute `?next=` a guest page may follow after login: Sembark's
 * own OAuth consent page on the API host, which sends a guest to the SPA
 * login and expects the browser back once the session cookie exists.
 * Anything else would turn `?next=` into an open redirect.
 */
export function allowedExternalRedirect(
	next: string | null | undefined,
	serverBase: string | undefined
): string | null {
	if (!next || !/^https?:\/\//i.test(next) || !serverBase) {
		return null
	}
	try {
		const target = new URL(next)
		const api = new URL(serverBase)
		return target.origin === api.origin &&
			target.pathname === OAUTH_AUTHORIZE_PATH
			? target.toString()
			: null
	} catch {
		return null
	}
}

/**
 * Whether `next` points outside the SPA; such a value is never handed to the
 * in-app router.
 */
export function isAbsoluteUrl(next: string | null | undefined): boolean {
	return Boolean(next && /^[a-z][a-z0-9+.-]*:\/\//i.test(next))
}
